import { useEffect, useRef, useState } from "react";

type TimeLeft = {
  hours: number;
  minutes: number;
  seconds: number;
};

export function useCountdown(
  expiresAt: string | number,
  onExpire?: () => void,
) {
  const expiredRef = useRef(false);

  const getTimeLeft = (): TimeLeft => {
    const now = Date.now();
    const target = new Date(expiresAt).getTime();
    const diff = target - now;

    if (diff <= 0) {
      if (!expiredRef.current && onExpire) {
        onExpire();
        expiredRef.current = true;
      }
      return { hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      hours: Math.floor(diff / (1000 * 60 * 60)),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(getTimeLeft);

  useEffect(() => {
    expiredRef.current = false; // сброс если expiresAt поменялся

    const interval = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);

    return () => clearInterval(interval);
  }, [expiresAt]);

  return timeLeft;
}
